export const BadgeIcon = () => {
    return (
        <svg width="26" height="30" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-black dark:stroke-white">
            <path
                d="M13.0002 24.9993C19.4435 24.9993 24.6668 19.776 24.6668 13.3327C24.6668 6.88936 19.4435 1.66602 13.0002 1.66602C6.55684 1.66602 1.3335 6.88936 1.3335 13.3327C1.3335 19.776 6.55684 24.9993 13.0002 24.9993Z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.68366 23.1495L4.66699 38.3328L13.0003 33.3328L21.3337 38.3328L19.317 23.1328"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
